export const PENDING = 'Pending';
export const UPLOADED = 'Uploaded';
export const PROCESSING = 'Processing';
export const COMPLETED = 'Completed';
export const FAILED = 'Failed';
